import type React from 'react';
import { shallow } from 'zustand/shallow';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { useUnmount } from '../../hooks/useUnmount';
import useMobileSelectionStore from '@fabric-app/business/store/mobileSelection';
import { pick } from '@fabric-app/utils/object/manipulation';
import { Button } from '@fabric-app/ui/components/Button';

const ToggleResourceMobileMultiselectButton: React.FC = () => {
  const { mobileSelectModeIsActive, toggleMobileSelectModeIsActive, disableMobileSelectMode } =
    useMobileSelectionStore(
      (state) =>
        pick(state, [
          'mobileSelectModeIsActive',
          'toggleMobileSelectModeIsActive',
          'disableMobileSelectMode',
        ]),
      shallow,
    );

  const { isMobileView } = useResponsive({
    onWidthChange: ({ isMobileView }) => {
      if (!isMobileView) {
        disableMobileSelectMode();
      }
    },
  });

  useUnmount(disableMobileSelectMode);

  if (!isMobileView) return null;

  return (
    <Button
      variant="bg-secondary"
      active={mobileSelectModeIsActive}
      onClick={toggleMobileSelectModeIsActive}
    >
      {mobileSelectModeIsActive ? 'Cancel' : 'Select'}
    </Button>
  );
};

export default ToggleResourceMobileMultiselectButton;
